export default __webpack_public_path__ + "static/LastClassWhisper-5a3c40981748fa7d14e3635dd9a0b960.png";